/* Prop & Piston conversion layer: cart drawer, quick add, add-to-cart from anywhere. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = function (c) {
    return (window.ppMoney || '${{amount}}').replace(/\{\{\s*(amount|amount_no_decimals)\s*\}\}/, function (_, k) {
      var v = k === 'amount_no_decimals' ? Math.round(c / 100).toString() : (c / 100).toFixed(2);
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var img = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };

  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
    var dc = $('[data-cd-count]'); if (dc) dc.textContent = n ? '(' + n + ')' : '';
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var list = $('[data-cd-items]', drawer);
    var empty = cart.item_count === 0;
    $('[data-cd-empty]', drawer).hidden = !empty;
    $('[data-cd-foot]', drawer).hidden = empty;
    list.innerHTML = cart.items.map(function (it, i) {
      var opts = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="cd-item__opt">' + esc(it.variant_title) + '</span>' : '';
      var was = it.original_line_price > it.final_line_price ? ' <s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="cd-item">' +
        '<a class="cd-item__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
        '<div class="cd-item__info"><a class="cd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + opts +
        '<div class="cd-item__row"><div class="cd-qty" aria-label="Quantity">' +
        '<button type="button" data-cd-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-cd-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<strong>' + money(it.final_line_price) + was + '</strong></div>' +
        '<button type="button" class="cd-item__remove" data-cd-qty="' + (i + 1) + '" data-q="0">Remove</button></div></li>';
    }).join('');
    var sub = $('[data-cd-subtotal]', drawer); if (sub) sub.textContent = money(cart.total_price);

    var ship = $('[data-cd-ship]', drawer);
    if (ship) {
      var t = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
      var left = t - cart.total_price;
      ship.hidden = empty;
      $('[data-cd-ship-text]', ship).innerHTML = left > 0 ? 'You are <strong>' + money(left) + '</strong> away from free shipping.' : '<strong>You unlocked free shipping.</strong>';
      $('[data-cd-ship-bar]', ship).style.width = Math.min(100, Math.round(cart.total_price / t * 100)) + '%';
    }
    upsell(cart);
  }

  var upsellFor = null;
  function upsell(cart) {
    var box = drawer && $('[data-cd-upsell]', drawer);
    if (!box) return;
    if (!cart.items.length) { box.hidden = true; upsellFor = null; return; }
    var pid = cart.items[0].product_id;
    if (pid === upsellFor) return;
    upsellFor = pid;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var get = function (intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; });
    };
    get('complementary').then(function (j) {
      return j.products && j.products.length >= 2 ? j : get('related');
    }).then(function (j) {
      var picks = (j.products || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 3);
      if (!picks.length) { box.hidden = true; return; }
      $('[data-cd-upsell-list]', box).innerHTML = picks.map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0];
        var single = p.variants.length === 1;
        return '<div class="cd-up">' +
          '<a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt="" width="64" height="64" loading="lazy"></a>' +
          '<div><a class="cd-up__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span>' + money(v ? v.price : p.price) + '</span></div>' +
          (single && v ? '<button type="button" class="qa-btn qa-btn--sm" data-quick-add="' + v.id + '">Add</button>' : '<a class="qa-btn qa-btn--sm" href="' + esc(p.url) + '">Options</a>') +
          '</div>';
      }).join('');
      box.hidden = false;
    }).catch(function () { box.hidden = true; });
  }

  function refresh() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }

  function open(added) {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('cd-open');
    $('[data-cd-added]', drawer).hidden = !added;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); $('.cdrawer__panel', drawer).focus(); });
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cd-open');
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
      .then(refresh).then(function (c) { open(true); return c; });
  }

  window.PPCart = { add: add, open: open, close: close, refresh: refresh, enabled: !!drawer };

  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('data-label', btn.innerHTML); btn.disabled = true; btn.classList.add('is-busy'); }
    else { btn.disabled = false; btn.classList.remove('is-busy'); if (btn.getAttribute('data-label')) btn.innerHTML = btn.getAttribute('data-label'); }
  }
  function fail(btn, err) {
    busy(btn, false);
    var host = btn && (btn.closest('.card__quick') || btn.closest('.cd-up') || btn.parentNode);
    if (host) { var m = document.createElement('p'); m.className = 'qa-err'; m.textContent = err.message; host.appendChild(m); setTimeout(function () { m.remove(); }, 4000); }
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      busy(q, true);
      add([{ id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1 }]).then(function () { busy(q, false); }).catch(function (err) { fail(q, err); });
      return;
    }
    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      qty.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(qty.getAttribute('data-cd-qty'), 10), quantity: Math.max(0, parseInt(qty.getAttribute('data-q'), 10)) })
      }).then(function (r) { return r.json(); }).then(render).catch(function () { qty.disabled = false; });
      return;
    }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var cl = e.target.closest('.cart-link');
    if (cl && drawer && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); refresh(); open(false); }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-qa-form]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    busy(btn, true);
    add([{ id: parseInt(f.elements.id.value, 10), quantity: 1 }]).then(function () { busy(btn, false); }).catch(function (err) { fail(btn, err); });
  });

  /* Low stock note on product pages (only for variants Shopify tracks and has 5 or fewer of). */
  var low = document.querySelector('[data-low-stock]');
  if (low) {
    var map = {}; try { map = JSON.parse(low.getAttribute('data-low-stock')); } catch (e) {}
    var form = low.closest('form');
    var show = function () {
      var id = form && form.elements.id ? form.elements.id.value : '';
      var n = map[id];
      low.hidden = !n;
      if (n) low.textContent = 'Only ' + n + ' left in stock';
    };
    show();
    if (form) form.addEventListener('change', function () { setTimeout(show, 0); });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) close(); });
})();
